import { createSlice } from "@reduxjs/toolkit";

const initialCreateForm = {
  activity: "study",
  startTime: "now",
  pickedTime: "",
  location: "library",
  note: "",
  minParticipants: 3,
  spots: 6,
  duration: 10,
};

const meshNowSlice = createSlice({
  name: "meshNow",
  initialState: {
    createForm: initialCreateForm,
    selectedMeshId: null,
    joinedMeshId: null,
    lobbyMeshId: null,
    showCreate: false,
    completedMeshId: null,
    showMyMeshPanel: false,
    skippedIds: [],
  },
  reducers: {
    setCreateFormField(state, action) {
      const { field, value } = action.payload;
      state.createForm[field] = value;
    },
    resetCreateForm(state) {
      state.createForm = initialCreateForm;
    },
    setSelectedMesh(state, action) {
      state.selectedMeshId = action.payload;
    },
    clearSelectedMesh(state) {
      state.selectedMeshId = null;
    },
    setJoinedMesh(state, action) {
      state.joinedMeshId = action.payload;
    },
    clearJoinedMesh(state) {
      state.joinedMeshId = null;
    },
    setLobbyMesh(state, action) {
      state.lobbyMeshId = action.payload;
    },
    clearLobbyMesh(state) {
      state.lobbyMeshId = null;
    },
    setShowCreate(state, action) {
      state.showCreate = action.payload;
    },
    setCompletedMesh(state, action) {
      state.completedMeshId = action.payload;
    },
    clearCompletedMesh(state) {
      state.completedMeshId = null;
    },
    setShowMyMeshPanel(state, action) {
      state.showMyMeshPanel = action.payload;
    },
    addSkippedId(state, action) {
      if (!state.skippedIds.includes(action.payload)) {
        state.skippedIds.push(action.payload);
      }
    },
    clearSkippedIds(state) {
      state.skippedIds = [];
    },
  },
});

export const {
  setCreateFormField,
  resetCreateForm,
  setSelectedMesh,
  clearSelectedMesh,
  setJoinedMesh,
  clearJoinedMesh,
  setLobbyMesh,
  clearLobbyMesh,
  setShowCreate,
  setCompletedMesh,
  clearCompletedMesh,
  setShowMyMeshPanel,
  addSkippedId,
  clearSkippedIds,
} = meshNowSlice.actions;

export default meshNowSlice.reducer;
